// AmbientModal.ts — só o que a casca compartilhada (_casca.ts) não tem.
//
// Overlay, ModalContent, campos, botões e AlertMessage vêm todos de `_casca`;
// aqui ficam as três coisas que são deste modal: a loja travada (campo que
// parece campo mas não é editável), a linha de ajuda sob um campo, e o selo
// colorido do tipo escolhido.
//
// Tokens: só `var(--u)`, `var(--fs-*)` e `var(--sp-*)`. Cores por
// `props.theme.colors` com fallback — o tema real tem 5 chaves, `borderColor`
// resolve undefined (dívida herdada do repo, não consertada aqui).
import styled from "styled-components";

/**
 * A loja quando ela vem decidida de fora (o botão "Novo Ambiente" já sabe de
 * qual filial partiu).
 *
 * Não é um `<select disabled>` porque select desabilitado some do fluxo de
 * teclado e o usuário fica sem saber se é campo ou rótulo. Aqui é explícito:
 * cadeado + nome da loja, e o valor viaja no estado do formulário.
 */
export const LojaTravada = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  width: 100%;
  padding: var(--sp-10) var(--sp-12);
  border: 1px dashed ${(props) => props.theme.colors.borderColor || "#e0e0e0"};
  border-radius: 8px;
  background: #f4f7f9;
  color: ${(props) => props.theme.colors.text};
  font-size: var(--fs-md);
`;

/** Linha de ajuda sob um campo: o que o campo faz, sem virar um aviso. */
export const TextoDeAjuda = styled.small`
  display: block;
  margin-top: var(--sp-4);
  font-size: var(--fs-2xs);
  line-height: 1.5;
  color: #6b7885;
`;

/**
 * Espelho do selo que o cartão de ambiente desenha na tela de Ambientes: a
 * mesma cor e o mesmo ícone de `tiposDeAmbiente.ts`. Serve de confirmação —
 * o dono vê no formulário exatamente o que vai aparecer no cartão.
 */
export const SeloDoTipo = styled.span<{ $cor: string }>`
  display: inline-flex;
  align-items: center;
  gap: var(--sp-4);
  margin-top: var(--sp-8);
  padding: var(--sp-2) var(--sp-10);
  border-radius: 999px;
  font-size: var(--fs-2xs);
  font-weight: 600;
  color: ${(props) => props.$cor};
  background: ${(props) => props.$cor}18;
  border: 1px solid ${(props) => props.$cor}44;
`;
